import { FutureEntriesModalTranslations } from "./future-entries-modal-pt-br";

export const FUTURE_ENTRIES_MODAL_FR_FR: FutureEntriesModalTranslations = {
	title: "Entrées Futures",
	search: "Rechercher",
	return: "Retour",
	totalEntries: "{{count}} entrée",
	totalEntries_plural: "{{count}} entrées",
	totalForMonth: "Total des Entrées",
	columns: {
		month: "Mois",
		group: "GROUPEMENT",
		total: "Total",
		type: "TYPE",
		category: "CATÉGORIE",
		originDestination: "ORIGINE/DESTINATION",
		observation: "OBSERVATION",
		competenceDate: "DATE DE COMPÉTENCE",
		liquidationDate: "DATE DE RÈGLEMENT",
		value: "VALEUR",
		totalReleases: "Total des Entrées",
		emptyText: "Aucune entrée future trouvée",
	},
	excel: {
		title: "Entrées Futures - {{startDate}} à {{endDate}}",
		fileName: "entrees-futures-{{startDate}}-{{endDate}}",
	},
};
